module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-1-large-ec1e4fb8fb330ad8533a7ba55cd2e7a5.jpg";